import { SVGProps, Ref, forwardRef } from 'react';

export const ConstructionHatFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.38 2c1.72 0 2.58 0 3.152.518.25.226.407.518.519.919.143.512.213 1.203.31 2.165L17.1 13h1.808l-.758-7.577a43 43 0 0 0-.14-1.266c3.64 1.843 4.742 5.9 4.948 12.229A3.28 3.28 0 0 1 24 18.778c0 1.342-.84 2.487-2.168 2.683-1.779.262-4.838.539-9.832.539s-8.053-.277-9.832-.54C.841 21.266 0 20.12 0 18.779c0-.935.397-1.79 1.04-2.392C1.247 10.056 2.347 6 5.987 4.157c-.052.401-.095.83-.138 1.266L5.09 13h1.808l.74-7.398c.127-1.262.206-2.058.468-2.597.094-.192.21-.351.36-.487.43-.388 1.02-.486 2.015-.51L11.62 2zM6.5 17.9h11v-1.8h-11z"
                fill="currentColor"
            />
        </svg>
    )
);
ConstructionHatFilledSize24Glyph.displayName = 'ConstructionHatFilledSize24Glyph';
